module.exports = __webpack_public_path__ + "img/loyalty.1797edd.svg";